function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import 'url-search-params-polyfill';
/**
 * get meta object from meta tag fs-prop="analytics" on the main article (first article on the 3things)
 * @returns {object} Meta Object
 */

export function getPageMetadata() {
  var data = {};
  var metaEl = document.querySelector('[fs-prop="analytics"]');
  if (!metaEl) return data;
  var atts = metaEl.attributes;

  for (var i = 0, len = atts.length; i < len; i++) {
    if (atts[i].value != null) {
      var att = atts[i].name;
      var val = atts[i].value;
      att = att.indexOf('-') >= 0 ? att.replace(/-/g, '_') : att;
      data[att] = val.trim();
    }
  }

  return data;
} // query string helpers

export function setCampaignTraitsSession() {
  if (window.location.search.length == 0) return;
  var queryStr = window.location.search;
  var campaignTraits = {
    "org": "campaign_organization",
    "ag": "campaign_agency",
    "mc": "campaign_type",
    "src": "campaign_source",
    "cmp": "campaign_name",
    "add": "campaign_additional",
    "cmpid": "campaign_tracking_code"
  };
  var query = new URLSearchParams(queryStr);
  var params = Object.keys(campaignTraits);
  var result;

  for (var _iterator = query.keys(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var key = _ref;

    if (key in params) {
      if (!result) result = {};
      result[campaignTraits[key]] = query.get(key);
    }
  }

  if (result) {
    window.sessionStorage.setItem('sessionCampaignTraits', JSON.stringify(result));
  }

  return result;
}
;
export function getSessionCampaignTraits() {
  var result;

  try {
    result = JSON.parse(window.sessionStorage.getItem('sessionCampaignTraits'));

    if (!result) {
      result = setCampaignTraitsSession();
    }
  } catch (e) {
    return;
  }

  return result;
}
;
/*
`lastAnonymousProfileId`
 + populate when user hasn't logged in
 + pass blank on tracking when user is logged in
 + pass last anon id if user is logged out (?)

`lastKnownProfileId`
 + pass blank when user hasn't logged in
 + populate when user logs out
 + pass blank when user logs back in (?)
*/

function isObjectEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }

  return true;
}

export function getProfileData(objData) {
  if (objData === void 0) {
    objData = {};
  }

  var wisReg = window.wisRegistration;

  if (wisReg) {
    var isLoggedIn = isUserLoggedIn();

    if (isLoggedIn) {
      var profileId = getUsrProfileId() || '';
      objData.dcg_profile_id = profileId || '';
      sessionStorage.setItem('lastKnownProfileId', profileId);
    }

    objData.lastKnownProfileId = sessionStorage.getItem('lastKnownProfileId') || '';
    var lastAnonProfileId = getAnonProfileId(wisReg) || sessionStorage.getItem('lastAnonymousProfileId');
    objData.lastAnonymousProfileId = lastAnonProfileId || '';
    sessionStorage.setItem('lastAnonymousProfileId', objData.lastAnonymousProfileId);
  }

  return objData;
}
export function getJWT() {
  return _getJWT.apply(this, arguments);
}

function _getJWT() {
  _getJWT = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee() {
    var wisReg;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            wisReg = window.wisRegistration;

            if (!wisReg) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", wisReg.getJWT());

          case 3:
            return _context.abrupt("return", null);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getJWT.apply(this, arguments);
}

function getUsrProfileId() {
  var wisReg = window.wisRegistration;

  if (typeof wisReg.getProfileId === "function") {
    return wisReg.getProfileId();
  }

  return null;
}

function getAnonProfileId(wisReg) {
  if (typeof wisReg.getAnonProfileId === "function") {
    return wisReg.getAnonProfileId();
  }

  return null;
}

function isUserLoggedIn() {
  var wisReg = window.wisRegistration;

  if (wisReg && typeof wisReg.isUserLoggedIn === "function") {
    return wisReg.isUserLoggedIn();
  }

  return null;
}

export function getAuthData() {
  return _getAuthData.apply(this, arguments);
}

function _getAuthData() {
  _getAuthData = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2() {
    var profile, geo, auth;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            profile = getProfileData();
            geo = getGeoLocation();
            _context2.t0 = isProfileAnon();
            _context2.t1 = profile.dcg_profile_id || null;
            _context2.next = 6;
            return getJWT();

          case 6:
            _context2.t2 = _context2.sent;
            _context2.t3 = profile.lastKnownProfileId;
            _context2.t4 = profile.lastAnonymousProfileId;
            _context2.t5 = {
              profileAnonymous: _context2.t0,
              profileId: _context2.t1,
              accessToken: _context2.t2,
              lastKnownProfileId: _context2.t3,
              lastAnonymousProfileId: _context2.t4
            };
            _context2.t6 = getMVPDId();
            _context2.next = 13;
            return getUserEntitlementsList();

          case 13:
            _context2.t7 = _context2.sent;
            _context2.t8 = _extends({}, geo);
            auth = {
              upstreamUserID: null,
              profile: _context2.t5,
              authorizingNetwork: null,
              mvpdId: _context2.t6,
              networkEntitlementList: _context2.t7,
              geo: _context2.t8
            };
            return _context2.abrupt("return", auth);

          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getAuthData.apply(this, arguments);
}

export function isProfileAnon() {
  var isLoggedIn = isUserLoggedIn();

  if (isLoggedIn) {
    return !isLoggedIn;
  }

  return true;
}
/**
 * set geo location on session storage
 */

export function setGeoLocation() {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function (pos) {
      var geo = {
        geoLatitude: pos.coords.latitude,
        geoLongitude: pos.coords.longitude
      };
      sessionStorage.setItem('fs_geolocation', JSON.stringify(geo));
    });
  }
}
/**
* get geo location from session storage
*/

export function getGeoLocation() {
  // Get geolocation data from sessionStorage
  var geo = sessionStorage.getItem('fs_geolocation');

  if (geo) {
    return JSON.parse(geo);
  }

  return {
    geoLatitude: null,
    geoLongitude: null
  };
}
export function getUserEntitlementsList() {
  return _getUserEntitlementsList.apply(this, arguments);
}
/**
 * returns mvpd id
 */

function _getUserEntitlementsList() {
  _getUserEntitlementsList = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3() {
    var wisReg, entitlements, channels, ppvEvents, formmattedList;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            wisReg = window.wisRegistration;

            if (!wisReg) {
              _context3.next = 13;
              break;
            }

            _context3.next = 4;
            return wisReg.getUserEntitlements();

          case 4:
            entitlements = _context3.sent;

            if (entitlements) {
              _context3.next = 7;
              break;
            }

            return _context3.abrupt("return", null);

          case 7:
            channels = entitlements.channels.map(function (e) {
              return e.name;
            });
            ppvEvents = entitlements.ppvEvents.map(function (e) {
              return e.uri;
            });
            formmattedList = '';

            if (channels) {
              formmattedList = channels.toString();
            }

            if (ppvEvents && ppvEvents.length > 0) {
              formmattedList += "," + ppvEvents.toString();
            }

            return _context3.abrupt("return", formmattedList);

          case 13:
            return _context3.abrupt("return", null);

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getUserEntitlementsList.apply(this, arguments);
}

export function getMVPDId() {
  var wisReg = window.wisRegistration;

  if (wisReg && typeof wisReg.getMVPDDetails === "function") {
    var details = wisReg.getMVPDDetails();

    if (details) {
      return details.providerId;
    }

    return null;
  }
}